import { render, staticRenderFns } from "./Team-Programm.vue?vue&type=template&id=7050c03e&"
import script from "./Team-Programm.vue?vue&type=script&lang=js&"
export * from "./Team-Programm.vue?vue&type=script&lang=js&"
import style0 from "./Team-Programm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports